import Navmenu from "./navMenu";
import { AppContext } from "../context/AppContext";
import React, { useContext, useEffect, useState } from "react";
import { Grid } from "antd";
import { getMenuSections } from "./menuFilters";

const Sidebar = () => {
  const { user, menus, company } = useContext(AppContext);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [isOpen, setIsOpen] = useState(false);

  // Shared with the top-nav so both layouts show identical items.
  const { mainMenuItems, reportMenuItems } = getMenuSections(
    menus,
    user,
    company,
  );

  // Handle mobile sidebar toggle
  useEffect(() => {
    if (isMobile) {
      const handleSidebarToggle = () => {
        setIsOpen(!isOpen);
      };

      const toggleButton = document.querySelector(".sidebar-toggle");
      if (toggleButton) {
        toggleButton.addEventListener("click", handleSidebarToggle);
        return () =>
          toggleButton.removeEventListener("click", handleSidebarToggle);
      }
    }
  }, [isMobile, isOpen]);

  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && isOpen && (
        <div
          className="sidebar-backdrop show"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside
        className={`main-sidebar ${isMobile && isOpen ? "sidebar-open" : ""}`}
      >
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                src="/dist/img/dummy.jpeg"
                className="img-circle"
                alt="User Image"
              ></img>
            </div>
            <div
              className="pull-left info"
              style={{ display: "flex", alignItems: "center", height: "100%" }}
            >
              <p>{user?.role}</p>
            </div>
          </div>
          <ul className="sidebar-menu" key={user?.id} data-widget="tree">
            <li className="header">MAIN MENU</li>
            {mainMenuItems.map((item) => (
              <Navmenu
                key={item.id} // using a unique key
                link={item.link}
                text={item.text}
                icon={item.icon}
                type={item.type}
                hasCount={item.hasCount}
                count={item.count}
                subItems={item.sub_menus}
              />
            ))}

            {/* Only show REPORTS header and report items for Administrator role */}
            {user?.role === "Administrator" && (
              <>
                <li className="header">REPORTS</li>
                {reportMenuItems.map((item) => (
                  <Navmenu
                    key={item.id}
                    link={item.link}
                    text={item.text}
                    icon={item.icon}
                    type={item.type}
                    hasCount={item.hasCount}
                    count={item.count}
                    subItems={item.sub_menus}
                  />
                ))}
              </>
            )}
          </ul>
        </section>
      </aside>
    </>
  );
};

export default Sidebar;
